import React, { useState } from "react";

//UI Material
import { Avatar, Card, CircularProgress, Grid, Stack } from "@mui/material";

//Material Icons
import { Comment } from "@mui/icons-material";

//Helpers
import {
  typographyForCustomizedFontSize,
  typographyForSubtitles,
  typographyForText,
} from "../../Helpers/typography";
import { selectDateString } from "../../Helpers/date";

//Local components
import ContainedButton from "../basics/ContainedButton";
import AddCommentDrawer from "../drawers/AddCommentDrawer";

export default function OrderComments({
  comments = [],
  loading = false,
  getComments,
  orderNumber,
}) {
  // ==========>Component States<==========
  const [openCommentDrawer, setOpenCommentDrawer] = useState(false);
  //User data from localStorage
  const userData = JSON.parse(localStorage.getItem("userData"));

  // ==========>Component Functions<==========
  const generateOrderComments = () => {
    const orderedComments = comments.sort(
      (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
    );
    return orderedComments.map((comment) => (
      <Grid item xs={12} key={`${comment.commentNumber}`}>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          textAlign="left"
          justifyContent={
            userData.email === comment.createdBy ? "flex-end" : "flex-start"
          }
        >
          {userData.email !== comment.createdBy && (
            <Avatar sx={{ width: "37px", height: "37px" }}>
              {comment.createdBy[0]}
            </Avatar>
          )}
          <Card raised sx={{ padding: "20px" }}>
            <Stack spacing={0.2}>
              {typographyForCustomizedFontSize(comment.comment, "13.5px")}
              <Stack direction="row" alignItems="center" spacing={1}>
                {userData.email === comment.createdBy
                  ? typographyForCustomizedFontSize(
                      selectDateString(comment.createdAt),
                      "11px",
                      null
                    )
                  : typographyForCustomizedFontSize(
                      `${selectDateString(
                        comment.createdAt
                      )} por ${comment.createdBy}`,
                      "11px",
                      null
                    )}
              </Stack>
            </Stack>
          </Card>
          {userData.email === comment.createdBy && (
            <Avatar sx={{ width: "37px", height: "37px" }}>
              {comment.createdBy[0]}
            </Avatar>
          )}
        </Stack>
      </Grid>
    ));
  };

  /**
   * Function to generate comments according to loading state and the array length
   * @returns the component to display in the comments section
   */
  const generateComments = () => {
    if (loading) {
      return (
        <Grid item xs={12} sx={{ marginTop: "10px" }}>
          <CircularProgress size={30} />
        </Grid>
      );
    } else {
      return !comments.length ? (
        <Grid item xs={12}>
          {typographyForText("Aún no hay comentarios.")}
        </Grid>
      ) : (
        generateOrderComments()
      );
    }
  };

  return (
    <Card raised sx={{ height: "100%" }}>
      <AddCommentDrawer
        open={openCommentDrawer}
        setOpen={setOpenCommentDrawer}
        getData={getComments}
        orderNumber={orderNumber}
      />
      <Grid container spacing={2} sx={{ padding: "15px" }}>
        <Grid item xs={12}>
          {typographyForSubtitles("Comentarios", "secondary")}
        </Grid>
        {generateComments()}

        <Grid item xs={12}>
          <ContainedButton
            text="Agregar comentario"
            startIcon={<Comment />}
            onClick={() => {
              setOpenCommentDrawer(true);
            }}
          />
        </Grid>
      </Grid>
    </Card>
  );
}
